// @vendors
const Immutable = require('immutable');

// @utilities
const { getLanguage } = require('core/i18n').i18n;

// @actionTypes
const actionTypes = require('constants/actionTypes');


function setInitialState() {
    const language = getLanguage();
    const languageStrings = {
        [language]: {},
        'es': {}
    }
    return Immutable.fromJS({
        translations: languageStrings,
        errorPRI: false,
        isFetchingPRI: false,
        hasBeenFetchedPRI: false,
        errorCC: false,
        isFetchingCC: false,
        hasBeenFetchedCC: false,
    });
}

const reducer = (state = setInitialState(), action) => {
    switch (action.type) {
        case actionTypes.TRANSLATIONS_FETCH_REQUEST:
            return state.merge({
                [`isFetching${action.platform}`]: true,
                [`error${action.platform}`]: false
            });

        case actionTypes.TRANSLATIONS_REQUEST_SUCCESS:
            return state.mergeDeep({
                ['translations']: (action && action.payload && action.payload.translations) || {},
                [`isFetching${action.payload.platform}`]: false,
                [`error${action.payload.platform}`]: false,
                [`hasBeenFetched${action.payload.platform}`]: true,
            });

        case actionTypes.TRANSLATIONS_REQUEST_FAILURE:
            return state.merge({
                [`isFetching${action.platform}`]: false,
                [`error${action.platform}`]: true,
                [`hasBeenFetched${action.platform}`]: true,
            });

        default:
            return state;
    }
};

module.exports = reducer;
